import styled from "styled-components";
import Box from "ui-box";

export default styled(Box)`
  background-color: #e3e8ee;
  width: 100%;
  padding: 20px 20px 0;
`;
